import dynamic from "next/dynamic";
import { useState } from "react";

import Button from "components/shared/button/Button";
import Container from "components/shared/container/Container";

import {
    DetailsStyled,
    Content,
    Heading,
    Row,
    Block,
    Title,
    Text,
    Contact
} from "./Details.styled";

const ContactFormModal = dynamic(() =>
    import("components/shared/contactForm/modal/Modal")
);

export default function Details() {
    const [modalIsOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <DetailsStyled>
            <Container>
                <Content>
                    <Heading>
                        Het cadeau waar je de ontvanger{" "}
                        <strong>letterlijk</strong> mee verrast
                    </Heading>
                    <Row>
                        <Block>
                            <Title>Boeken, tijdschriften en e-books</Title>
                            <Text>
                                Het besteden van de Lees! Cadeaukaart gaat heel
                                makkelijk en kan zowel online als in de winkel.
                                Hierbij is de cadeaukaart in delen te besteden
                                aan het brede assortiment van tijdschriften,
                                boeken en e-books. Dankzij dit brede
                                assortiment, zal er altijd wel wat voor jou
                                tussen zitten!
                            </Text>
                        </Block>
                        <Block>
                            <Title>Snelle en persoonlijke service</Title>
                            <Text>
                                Persoonlijk contact. Geen wachtmuziek of
                                keuzemenu’s, maar iemand die je meteen verder
                                kan helpen. Daarnaast denken wij graag met je
                                mee als je speciale wensen of vragen hebt.
                            </Text>
                        </Block>
                    </Row>
                    <Contact>
                        <Title>Meer weten? Neem contact met ons op!</Title>
                        <Button variant="ghost" onClick={openModal}>
                            Neem contact op
                        </Button>
                        {modalIsOpen && (
                            <ContactFormModal
                                openModal={modalIsOpen}
                                closeModal={closeModal}
                            />
                        )}
                    </Contact>
                </Content>
            </Container>
        </DetailsStyled>
    );
}
